import type { ICustomerApi } from "../interfaces/ICustomerApi";
import type { CustomerMeDto } from "../../shared/CustomerMeDto";
import type { PartyAddressDto } from "../../shared/PartyAddressDto";

export class CustomerService {
  readonly api: ICustomerApi;

  constructor(api: ICustomerApi) {
    this.api = api;
  }

  // Stammdaten des eingeloggten Kunden, null ohne Login
  async me(): Promise<CustomerMeDto | null> {
    return await this.api.me();
  }

  // Stammdaten in das Adressformular des Checkouts uebernehmen
  static toPartyAddress(me: CustomerMeDto): PartyAddressDto {
    return {
      email: me.email,
      firstName: me.firstName,
      lastName: me.lastName,
      streetName: me.streetName,
      buildingNumber: me.buildingNumber,
      address2: me.address2,
      countryCode: me.countryCode || "CH",
      zipCode: me.zipCode,
      city: me.city,
      phoneP: me.phoneP,
      mobile: me.mobile,
      phoneB: me.phoneB,
      birthdate: me.birthdate,
    };
  }
}
